module.exports = __webpack_public_path__ + "static/img/funkwerks.4d7f854.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/funkwerks.jpg
// module id = 295
// module chunks = 1